import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutGPMappingTable extends Layout {
    sourceGPMapping: DataSource;
    tableGPMapping: Table;
}
